import type { CreateSourceState } from "@/pages/sources/components/create/sources/types";

export enum CreateSourceWikipediaPhase {
  IDLE = "IDLE",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export type CreateSourceWikipediaState = CreateSourceState & {
  seedUrl: string;
  linksPerPage: number;
  crawlDepth: number;
  maxPages: number;
  phase: CreateSourceWikipediaPhase;
};

export enum WikipediaPageEstimateSeverity {
  SUCCESS = "SUCCESS",
  CAUTION = "CAUTION",
  WARNING = "WARNING",
  ERROR = "ERROR",
}
